import {
  wixDocsNavigationClick,
  wixDocsSiteVisit,
  wixDocsVisitLocalViewer,
} from '../BiAnalyticsLogger/events';
import { NAV_TYPES } from '../BiAnalyticsLogger/events/consts';

export class BaseLogger {
  constructor(isLocalViewer, isBranch) {
    this.isLocalViewer = isLocalViewer;
    this.isBranch = isBranch;
    this.lastNavigatedArticle = '';
  }

  isLogNeeded(event = '', ...params) {
    if (this.isBranch) {
      return false;
    }
    if (this.isLocalViewer) {
      return event === wixDocsVisitLocalViewer;
    }
    if (event === wixDocsNavigationClick || event === wixDocsSiteVisit) {
      const detailsObject = params[0];
      const currentNavigatedArticle = `${detailsObject.category_name}/${detailsObject.article_name}`;
      if (detailsObject.nav_type === NAV_TYPES.SCROLL) {
        const shouldFireScrollEvent =
          this.lastNavigatedArticle !== currentNavigatedArticle;
        if (!shouldFireScrollEvent) {
          return false;
        }
      }
      this.lastNavigatedArticle = currentNavigatedArticle;
    }
    return true;
  }
}
